import genererCritereRechercheDemandeImpression from '@/services/logistique/demandeImpression/genererCritereRechercheDemandeImpression';
import { getAll as pGetAllDemandeImpression } from '@/api/logistique/demandeImpression';
import getAll from '@/api/logistique/demandeImpression/demandeImpressionRegroupement';
import * as types from '@/store/modules/logistique/demandeImpression-mutation-type';
import transformer from '@/services/logistique/demandeImpression/demandeImpressionServerTableDataTransformer';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import * as allTypes from '../../mutation-type';

function initialState() {
  return {
    items: [],
    total: 0,
    lastPayload: {},
    critereRecherche: genererCritereRechercheDemandeImpression(),
    demandeRegroupements: [],
    demandeRegroupementTotal: 0,
    campagne: null,
    demandeImpression: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [types.SET_ITEMS_VIEW](state, demandeRegroupements) {
    state.demandeRegroupements = demandeRegroupements;
  },
  [types.SET_TOTAL_VIEW](state, demandeRegroupementTotal) {
    state.demandeRegroupementTotal = demandeRegroupementTotal;
  },
  [types.SET_CRITERES](state, critereRecherche) {
    state.critereRecherche = critereRecherche;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_CAMPAGNE](state, value) {
    state.campagne = value;
  },
  [types.SET_DEMANDE_IMPRESSION](state, value) {
    state.demandeImpression = value;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadDemandeImpression({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD, data);
    const demandeImpressions = await pGetAllDemandeImpression(data);
    if (!data.withoutImage) await getPiecesJointeLogoByIds(demandeImpressions.data.result.items, 'campagneId');
    demandeImpressions.data.result.items.forEach((demandeImpression) => {
      demandeImpression.selected = false;
      demandeImpression.selectedFusion = false;
    });
    commit(types.SET_TOTAL, demandeImpressions.data.result.totalCount);
    commit(types.SET_ITEMS, demandeImpressions.data.result.items);
    return {};
  },

  async loadDemandeImpressionView({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD, data);
    const response = await getAll(data);
    if (!data.withoutImage) await getPiecesJointeLogoByIds(response.data.result.items, 'campagneId');
    response.data.result.items.forEach((demandeImpression) => {
      demandeImpression.selected = false;
      demandeImpression.demandeImpressions.forEach(d => { d.selected = false; });
    });
    commit(types.SET_ITEMS_VIEW, response.data.result.items);
    commit(types.SET_TOTAL_VIEW, response.data.result.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  demandeRegroupements: state => {
    return state.demandeRegroupements;
  },
  demandeRegroupementTotal: state => {
    return state.demandeRegroupementTotal;
  },
  critereRecherche: state => {
    return state.critereRecherche;
  },
  lastPayload: state => {
    return transformer(state.lastPayload);
  },
  campagne: state => {
    return state.campagne;
  },
  demandeImpression: state => {
    return state.demandeImpression;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
